import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
let alldata = null;
if (sessionStorage.getItem("alldata")) {
  let datas = sessionStorage.getItem("alldata");
  alldata = JSON.parse(datas);
}

export default new Vuex.Store({
  state: {
    device:'desktop',
    alldata:alldata,
  },
  mutations: {
    changeDevice(state,value){
      state.device = value;
    },
    changealldata(state,value){
      state.alldata = JSON.parse(value);
    }
  },
  actions: {

  }
})
